import { ResponsiveBar } from "@nivo/bar";
import { schemeCategory10 } from "d3-scale-chromatic";
import { Pane } from "evergreen-ui";
import { useEffect, useMemo, useState } from "react";

const MainChart = (props) => {
    const [legend, setLegend] = useState(props.keys || []);

    useEffect(() => {
        if (props.keys?.length) {
            setLegend(props.keys);
        }
    }, [props.keys]);

    const toggle = (key) => {
        setLegend((prev) =>
            prev.includes(key)
                ? prev.filter((k) => k !== key)
                : [...prev, key]
        );
    };

    // Map consistent colors based on key index
    const colorMap = useMemo(() => {
        const map = {};
        props.keys?.forEach((key, i) => {
            map[key] = schemeCategory10[i % schemeCategory10.length];
        });
        return map;
    }, [props.keys]);

    // Don't render until we have proper data and keys
    if (!props.keys?.length || !props.data || Object.keys(props.data).length === 0) {
        return <Pane height={500} display="flex" alignItems="center" justifyContent="center">Loading...</Pane>;
    }

    return (
        <Pane height={500}>
            <ResponsiveBar
                data={Object.values(props.data)}
                keys={legend}
                indexBy="timeGroup"
                labelSkipWidth={12}
                labelSkipHeight={12}
                legends={[
                    {
                        dataFrom: "keys",
                        anchor: "bottom-right",
                        direction: "column",
                        translateX: 120,
                        itemsSpacing: 3,
                        itemWidth: 100,
                        itemHeight: 16,
                        onClick: (d) => toggle(d.id),
                        symbolSize: 14,
                        data: props.keys.map((key) => ({
                            id: key,
                            label: legend.includes(key) ? key : `(X) ${key}`,
                            color: legend.includes(key)
                                ? colorMap[key]
                                : `${colorMap[key]}80`, // transparent if disabled
                        })),
                    },
                ]}
                colors={({ id }) => colorMap[id] || "#999"}
                axisBottom={{ legend: "Time", legendOffset: 32 }}
                axisLeft={{ legend: "Sales", legendOffset: -40 }}
                margin={{ top: 50, right: 130, bottom: 50, left: 60 }}
            />
        </Pane>
    );
};

export default MainChart;
